import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("dataops.orchestrator"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [_c("template", { slot: "actions" })],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              [
                _c(
                  VContainer,
                  { staticClass: "justify-center", attrs: { fluid: "" } },
                  [
                    _c(
                      VForm,
                      {
                        ref: "form",
                        staticClass: "form mt-2",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.valid,
                          callback: function ($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid",
                        },
                      },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              {
                                staticClass: "d-flex align-center",
                                attrs: { cols: "3", lg: "2" },
                              },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Ambiente de origen")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(VSelect, {
                                  staticClass: "mt-2",
                                  attrs: {
                                    items: _vm.orchestrator.enviroment_in,
                                    rules: [
                                      _vm.rules.required,
                                      _vm.rules.itemsNotEmpty,
                                    ],
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: { change: _vm.listJobs },
                                  model: {
                                    value: _vm.form.enviroment_in,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "enviroment_in", $$v)
                                    },
                                    expression: "form.enviroment_in",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "d-flex align-center",
                                attrs: { cols: "3", lg: "2" },
                              },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Ambiente de destino")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(VSelect, {
                                  staticClass: "mt-2",
                                  attrs: {
                                    items: _vm.orchestrator.enviroment_out,
                                    rules: [
                                      _vm.rules.required,
                                      _vm.rules.itemsNotEmpty,
                                    ],
                                    outlined: "",
                                    dense: "",
                                    "item-text": "text",
                                    "item-value": "value",
                                  },
                                  model: {
                                    value: _vm.form.enviroment_out,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "enviroment_out", $$v)
                                    },
                                    expression: "form.enviroment_out",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "6" } },
                              _vm._l(_vm.jobs, function (job, index) {
                                return _c(
                                  VRow,
                                  { key: job.id, attrs: { dense: "" } },
                                  [
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "d-flex align-center",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _c(
                                          VSubheader,
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("#" + _vm._s(job.id))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(VAutocomplete, {
                                          staticClass: "mt-2",
                                          attrs: {
                                            items: _vm.jobsoris,
                                            rules: [
                                              _vm.rules.required,
                                              _vm.rules.itemsNotEmpty,
                                            ],
                                            outlined: "",
                                            dense: "",
                                          },
                                          model: {
                                            value: job.jobDetail,
                                            callback: function ($$v) {
                                              _vm.$set(job, "jobDetail", $$v)
                                            },
                                            expression: "job.jobDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      {
                                        staticClass:
                                          "mt-2 align-left justify-center",
                                        attrs: { cols: "4" },
                                      },
                                      [
                                        _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.viewJob(index)
                                              },
                                            },
                                          },
                                          [_c(VIcon, [_vm._v("icon-view")])],
                                          1
                                        ),
                                        _vm.jobs.length > 1
                                          ? _c(
                                              VBtn,
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeJob(index)
                                                  },
                                                },
                                              },
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-delete-outline"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        index + 1 === _vm.jobs.length
                                          ? _c(
                                              VBtn,
                                              {
                                                attrs: { icon: "" },
                                                on: { click: _vm.addJob },
                                              },
                                              [
                                                _c(VIcon, [
                                                  _vm._v("icon-add"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "6" } },
                              [
                                _vm.detail.Variables.length > 0
                                  ? _c(
                                      VCard,
                                      [
                                        _c(
                                          VCardTitle,
                                          { staticClass: "ma-0" },
                                          [
                                            _vm._v(
                                              " Job: " +
                                                _vm._s(_vm.detail.JobName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          VCardText,
                                          { staticClass: "ma-0" },
                                          [
                                            _c(
                                              VList,
                                              { attrs: { dense: "" } },
                                              [
                                                _c(
                                                  VListItemGroup,
                                                  _vm._l(
                                                    _vm.detail.Variables,
                                                    function (variable, index) {
                                                      return _c(
                                                        VListItem,
                                                        { key: index },
                                                        [
                                                          _c(
                                                            VListItemContent,
                                                            [
                                                              _c(
                                                                VListItemTitle,
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Variable:"
                                                                    ),
                                                                  ]),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        variable.Variable
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                VListItemSubtitle,
                                                                [
                                                                  _c("div", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Name:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          variable
                                                                            .Definition
                                                                            .name
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _c("div", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Type:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          variable
                                                                            .Definition
                                                                            .type
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _c("div", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Scope:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          variable
                                                                            .Definition
                                                                            .scope
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _c("div", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Visibility:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          variable
                                                                            .Definition
                                                                            .visibility
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _c("div", [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Value:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          variable.Value
                                                                        )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { staticClass: "text-right" },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "mb-3",
                                    attrs: { type: "button", color: "primary" },
                                    on: { click: _vm.save },
                                  },
                                  [_vm._v(" Registrar ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }